import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTranslate} from '@computerrock/formation-i18n';
import {useRouter} from '@computerrock/formation-router';
import {Modal, useStyles, ButtonSecondary, StickyBar} from '@ace-de/ui-components';
import InvoiceSummaryScreen from '../view-elements/InvoiceSummaryScreen';
import {createActiveInvoiceSubmissionsSelector, createInactiveInvoiceSubmissionsSelector} from '../invoiceSubmissionSelectors';
import modalIds from '../../modalIds';

const InvoiceSummaryViewModal = props => {
    const {cx} = useStyles();
    const {createTranslateShorthand} = useTranslate();
    const translateTab = createTranslateShorthand('invoice_submission');
    const {closeModal} = useRouter();
    const {invoiceSubmissions, hasBackdrop, location} = props;
    const invoiceSubmissionId = location?.query?.invoiceSubmissionId;
    const invoiceSubmission = invoiceSubmissions.find(invoiceSubmission => (
        invoiceSubmission.invoiceSubmissionId === invoiceSubmissionId
    ));

    if (!invoiceSubmission) return null;

    const {invoicingRemarks, paymentInfo} = invoiceSubmission;
    const files = invoiceSubmission.attachments?.files;

    return (
        <Modal
            className={cx([
                'global!ace-u-max-width--full',
                'global!ace-u-padding--large-32',
                'global!ace-u-padding--small-bottom-64',
            ])}
            contentClassName={cx([
                'global!ace-u-modal-content-size--s',
                'ace-c-modal__content--scrollable',
                'global!ace-u-padding--small-8',
            ])}
            hasBackdrop={hasBackdrop}
            hasBackdropNoPadding={true}
            title={(
                <h2
                    className={cx([
                        'global!ace-u-typography--variant-h2',
                        'global!ace-u-margin--small-bottom-24',
                    ])}
                >
                    {translateTab('invoice_summary_view.title')}
                </h2>
            )}
        >
            <div
                className={cx([
                    'global!ace-u-padding--small-bottom-64',
                    'global!ace-u-padding--large-bottom-0',
                    'global!ace-u-height--full',
                    'global!ace-u-width--full',
                ])}
            >
                <InvoiceSummaryScreen
                    files={files}
                    invoiceSubmission={invoiceSubmission}
                    isEditable={false}
                    invoicingRemarks={invoicingRemarks}
                    paymentInfo={paymentInfo}
                />
            </div>
            <StickyBar
                className={cx([
                    'global!ace-u-position--left-0',
                    'global!ace-u-width--full',
                    'global!ace-u-flex',
                    'global!ace-u-flex--small-direction-column',
                    'global!ace-u-flex--x-large-direction-row-reverse',
                    'global!ace-u-flex--small-align-center',
                    'ace-c-sticky-bar--bottom',
                ])}
            >
                <ButtonSecondary
                    name="closeSummary"
                    type="button"
                    onClick={() => closeModal(modalIds.INVOICE_SUMMARY_VIEW_MODAL, {invoiceSubmissionId})}
                    className={cx([
                        'global!ace-u-width--small-full',
                        'global!ace-u-width--large-auto',
                    ])}
                >
                    {translateTab('button_label.close')}
                </ButtonSecondary>
            </StickyBar>
        </Modal>
    );
};

InvoiceSummaryViewModal.propTypes = {
    hasBackdrop: PropTypes.bool,
    location: PropTypes.object.isRequired,
    invoiceSubmissions: PropTypes.array.isRequired,
};

InvoiceSummaryViewModal.defaultProps = {
    hasBackdrop: false,
};

const mapStateToProps = (state, props) => {
    const {history} = props;
    const isActiveTab = !history.location.pathname.includes('inactive');
    const getInvoiceSubmissions = isActiveTab
        ? createActiveInvoiceSubmissionsSelector() : createInactiveInvoiceSubmissionsSelector();
    return {
        invoiceSubmissions: getInvoiceSubmissions(state),
    };
};

export default connect(mapStateToProps)(InvoiceSummaryViewModal);
